import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import {UploadReportComponent} from '../upload-report/upload-report.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
//import { actionButtonConfiguration } from '../../../../l2-radiology/src/assets/data/actionButtonConfiguration';
import { actionButtonConfiguration } from '../../../../../l2-radiology/src/assets/data/actionButtonConfiguration';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-upload-report-data',
  templateUrl: './upload-report-data.component.html',
  styleUrls: ['./upload-report-data.component.scss']
})
export class UploadReportDataComponent implements OnInit {

  documents:[];
  uploadForm: FormGroup;
  @Input() orderObj;
  @Input() isUploadReportButton ;
  @Input() isUploadReportButtonReady;
  @Input() org_code;
  @Input() tenant_code;
  order_id :string;
  isReportUploaded  :Boolean=false;

  fileDownloadDisable :Boolean =true;
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  msg :string ="";
  actionButtonConfiguration;
  orderDetailsRes = {};
  isDelete:Boolean =false;
  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    public modal: NgbActiveModal,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService
    ) { }

  ngOnInit(): void {
    //this.isUploadReportButton =true;
    //console.log("ready="+this.isUploadReportButtonReady);
    //console.log(this.isUploadReportButton);
    //this.isUploadReportButton =true;
    this.actionButtonConfiguration =actionButtonConfiguration;
    this.documents=this.orderObj.order.documents;
    this.order_id=this.orderObj.order.patientinfo.order_id;
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    this.getOrderDataById(this.order_id);
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
    }

 //   const file = (event.target as HTMLInputElement).files[0];
 //   this.uploadForm.patchValue({
 //     avatar: file
 //   });
 //   this.uploadForm.get('avatar').updateValueAndValidity()
  }

  uploadFile(orderObj) {
//     //console.log("report upload called");
//     //console.log(orderObj);
//     const modalRef = this.modalService.open(UploadReportComponent);

//     const closeModelRef = modalRef.result.then(
//       (res) => {
// //console.log(res);
//        // this.getOrderDataById(this.id);

//       }

//     );

//     modalRef.componentInstance.orderObj = orderObj;

  }


  onSubmit(orderId) {
    this.msg = "";
    //console.log("uploaded orderId="+orderId);
    let formData = new FormData();
   // let uploadFormRequest = {};
   // //console.log(this.uploadForm.get('profile').value);
    formData.append('file[]', this.uploadForm.get('profile').value);
    //var formData: any = new FormData();
   // formData.append("name", this.uploadForm.get('file').value);
   // formData.append("avatar", this.uploadForm.get('avatar').value);
    formData.append("order_id", orderId);
    formData.append("channelCode",this.constantsService.CHANNEL_CODE);
    formData.append("actionById", window.localStorage.getItem('actionById'));
    formData.append("actionByName", window.localStorage.getItem('actionByName'));

    formData.append("source", "2");
    formData.append("orgCode", this.org_code);
    formData.append("tenantCode", this.tenant_code);
    //console.log(JSON.stringify(formData));
    this.omsServiceService.uploadFile(formData).subscribe(
      (res) => {

        //console.log(res);
        if(res["status"]==1)
        {
          this.isReportUploaded =true;
          this.isSuccessMsg =true;
          this.msg =res["message"];
          this.getOrderDataById(orderId);
          //this.changeOrderStatus(orderId);
        }else{
          this.isFailureMsg =true;
          this.msg =res["message"];
        }
      }

    )

  }


  changeOrderStatus(orderId) {
    if(this.documents !=undefined && this.documents.length >0)
    {

    this.spinnerService.show();
    let orderStatusChangeRequest = {};
    orderStatusChangeRequest["order_id"] = orderId;
    orderStatusChangeRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderStatusChangeRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderStatusChangeRequest["source"] = "1";
    orderStatusChangeRequest["status"] = this.constantsService.REPORT_UPLOADED_STATUS;
    orderStatusChangeRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderStatusChangeRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    orderStatusChangeRequest["type"] = "post";
    this.omsServiceService.changeStatusBasedOnReportUpload(orderStatusChangeRequest).subscribe(
      (res) => {
        // alert(res["message"]);
        this.toastr.success(res["message"]);
        this.spinnerService.hide();
        this.getOrderDataById(orderId);
      }
    )
    }else{
      // alert("No Records Uploaded");
      this.toastr.error("No Records Uploaded");
    }
    

  }

  getOrderDataById(id) {
    let orderRequest={};
    orderRequest["actionById"] = window.localStorage.getItem('actionById');;

    //this.orderRequest["actionById"] = "900001";

    orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;

    orderRequest["order_id"] = id;
    this.omsServiceService.getOrderDetails(orderRequest).subscribe(
      (res) => {

       if(res['status']==1)
       {
        // if(res["data"][0]["orderDetails"].order != undefined && res["data"][0]["orderDetails"].order.documents != undefined)
      //   {
          //this.documents =res["data"][0]["orderDetails"].order.documents;
          this.documents =res["data"][0].orderDetails[0].order.documents;
          this.orderDetailsRes = res["data"][0]["orderDetails"];
          this.enableButtons(this.orderDetailsRes);
        // }
         
       }
      }

    )
  }

  closePopup()
  {
    this.modal.close();
  }
  download(docId)
  {

    let downloadFileRequest ={};
    downloadFileRequest["doc_id"]=docId;
    downloadFileRequest["action"]="OMS/api/uploader.php/v4/orders/document/id";
    downloadFileRequest["type"]="post";
    this.omsServiceService.downloadFile(downloadFileRequest).subscribe(
      (res) => {
        //console.log(res);
        if(res["status"]==1)
        {
          //res["data"].url
          window.open(res["data"].url,'_blank');
        // window.location.href = res["data"].url;
        
        }
      }
    )
  }

  reportIsReady(orderId)
  { 

    this.spinnerService.show();
    //console.log("test");
    let orderStatusChangeRequest = {};
    orderStatusChangeRequest["order_id"] = orderId;
    orderStatusChangeRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderStatusChangeRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderStatusChangeRequest["source"] = "1";
    orderStatusChangeRequest["status"] = this.constantsService.REPORT_UPLOAD_READY_STATUS;
    orderStatusChangeRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderStatusChangeRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    orderStatusChangeRequest["type"] = "post";
    this.omsServiceService.changeStatusBasedOnReportUpload(orderStatusChangeRequest).subscribe(
      (res) => {
        //console.log(res);
        // alert(res["message"]);
        this.toastr.success(res["message"]);
        this.spinnerService.hide();
        this.getOrderDataById(orderId);
      }
    )
  }
  enableButtons(res)
  {
    this.isUploadReportButton = false;
    this.isUploadReportButtonReady = false;
    this.isDelete =false;
    let isUcdOrder = "";
    let status = res[0].OStatus;
    

    let isUploadButtonReadyObj = this.getConfigurationData(actionButtonConfiguration[0].uploadReportReady,window.localStorage.getItem('role'));
    var isUploadButtonReadyObjStatus = isUploadButtonReadyObj["status"];
    if (isUploadButtonReadyObjStatus !=null && isUploadButtonReadyObjStatus!=undefined && isUploadButtonReadyObjStatus.includes(status)) {
      this.isUploadReportButtonReady = true; 

    }

    let uploadReportObj = this.getConfigurationData(actionButtonConfiguration[0].uploadReport, window.localStorage.getItem('role'));
    var uploadReportObjStatus = uploadReportObj["status"];
    if (uploadReportObjStatus !=null&& uploadReportObjStatus!=undefined && uploadReportObjStatus.includes(status)) {
      if (window.localStorage.getItem('role') == "42") {
        //if (isUcdOrder != "" && isUcdOrder != undefined && isUcdOrder == "1") {
          this.isUploadReportButton = true;
       // }
      } else {
       // if (uploadReportObjStatus.includes(status)) {
          this.isUploadReportButton = true;
       // }


      }

    }

   

     if(status ==303 || status ==302)
     {
       this.isDelete =true;
     }

    
  }

  getConfigurationData(listOfData, role) {
    let obj = {};
    for (let data of listOfData) {

      if (role == data.role) {
        obj = data;
      }

    }
    return obj;
  }
  

  
  delete(docId,docName)
  {
    if(this.documents !=undefined && this.documents.length >1)
    {
      let deleteFileRequest ={};
    deleteFileRequest["order_id"]=this.order_id;
    deleteFileRequest["doc_id"]=docId;
    deleteFileRequest["filename"]=docName;
    //deleteFileRequest["channelCode"]=this.channel_code;
    deleteFileRequest["channelCode"]=this.constantsService.CHANNEL_CODE;
    deleteFileRequest["actionById"]=window.localStorage.getItem('actionById');
    deleteFileRequest["action"]="OMS/api/uploader.php/v4/orders/prescriptions/delete";
    deleteFileRequest["type"]="post";
    this.omsServiceService.deletePrescription(deleteFileRequest).subscribe(
      (res) => {
        //console.log(res);
        if(res["status"]==1)
        {
          //console.log(res);
          //res["data"].url
         // window.open(res["data"].url,'_blank');
        // window.location.href = res["data"].url;
        this.msg=res["message"];
        this.getOrderDataById(this.order_id);
        }else{
          this.msg=res["message"];
        }
        //console.log(res);
      }
    )

    }else{
      // alert("please upload accurate file and then delete");
      this.toastr.error("please upload accurate file and then delete");
    }

    
  }
  
}
